import { SwivlChat } from "@swivl-mono/chat";
import { Channel, DefaultEmbedConfig, From, IsSessionTakenOver, MessageInterface, SessionInterface, UserInterface } from "@swivl-mono/types";
import { Spinner } from "@swivl-mono/ui";
import { AnimatePresence, motion } from "motion/react";
import { useEffect, useState } from "react";
import { Member } from "../../../Models/Member/Member.Current";
import { UserConversationsInterface } from "../../../Models/Users/Users.Model";

import { MultiChannelChatSectionEmptyState } from "./MultiChannelChatSectionEmptyState";
import { AIModel } from "../../../Models/AI/AI.Model";
import CallModel, { CallBarPosition } from "../../../Models/CallModel/Call.Model";

interface MultiChannelChatSectionProps {
  channel: Channel,
  chatRef: React.RefObject<any>,
  user: UserInterface,
  conversation?: UserConversationsInterface,
  isQuickRepliesDropdownOpen?: boolean,
  isAutoCompleteEnabled?: boolean,
}

export function MultiChannelChatSection({ channel, chatRef, conversation, user, isQuickRepliesDropdownOpen, isAutoCompleteEnabled }: MultiChannelChatSectionProps) {
  const { currentConversationAIAutocompleteUserId } = AIModel.useState(s => s);
  const [isEmpty, setIsEmpty] = useState<boolean | undefined>(undefined);

  const session: SessionInterface | undefined = conversation?.sessions?.[channel] || undefined;

  const paddingBottom = isQuickRepliesDropdownOpen ? 16 + 134 : 16;
  const showEmptyState = isEmpty && !IsSessionTakenOver(session) ? true : false;

  const config: any = DefaultEmbedConfig;

  useEffect(() => {
    AIModel.setCurrentConversationAIAutocompleteUserId(user?.id)
  }, [user?.id])

  const auth = {
    userId: user.id,
    from: From.AGENT,
    orgId: Member.orgId,
    memberId: Member.id,
    token: user.token || "",
    channel: channel,
  }
  console.log('auth :', auth);

  return (
    <AnimatePresence mode="wait">
      <motion.div
        animate={{ paddingBottom: paddingBottom }}
        initial={{ paddingBottom: 0 }}
        key={isQuickRepliesDropdownOpen ? "quick-replies-open" : "quick-replies-closed"}
        className="flex flex-col size-full gap-2"
        transition={{ duration: 0.2, ease: "easeInOut" }}
      >
        {!user || !user.token ? <Spinner /> : <>
          <MultiChannelChatSectionEmptyState currentChannel={channel} hide={!showEmptyState} />
          <div className="flex flex-col items-center justify-center size-full overflow-y-auto" style={{ display: showEmptyState ? "none" : "flex" }}>
            <SwivlChat
              key={`chat-${channel}-user-${user.id}-session-${session?.id}`}
              auth={auth}
              from={From.AGENT}
              transcriptOnly={session ? false : true}
              canTakeOver={true}
              isConversationTakenOver={IsSessionTakenOver(session)}
              channel={channel}
              // takeoverConversation={takeoverConversation}
              config={config}
              server={import.meta.env.VITE_SERVER_URL}
              webSocketServer={import.meta.env.VITE_CHANNELS_WEBSOCKET_URL}
              messagingServer={import.meta.env.VITE_MESSAGING_SERVER_URL}
              commandCallback={(command: string) => { }}
              generateCSS={true}
              isOpen={true}
              isMobile={false}
              hideForm={true}
              parentControlsStart={false}
              loadPastMessagesBeforeConnect={true}
              ref={chatRef}
              // canTakeoverViaSMS={canTakeoverViaSMS}
              onConversationTranscriptUpdate={(transcript: MessageInterface[], fromInitialLoad: boolean) => {
                if (fromInitialLoad && (!transcript || transcript.length === 0)) {
                  setIsEmpty(true);
                } else if (isEmpty && transcript && transcript.length > 0) {
                  setIsEmpty(false);
                }
                // TODO: there was a hassentmessage condition to this conditional prior == investigate what it did
                if (isAutoCompleteEnabled && user && user.id === currentConversationAIAutocompleteUserId) {
                  console.log("Transcript update from chat component, sending to AI model", transcript);
                  AIModel.onConversationTranscriptUpdate(transcript, user.id)
                } else {
                  console.log("Transcript update from chat component, not sending to AI model", isAutoCompleteEnabled, user, user.id, "===", currentConversationAIAutocompleteUserId);

                }
              }}
            />
          </div>
        </>
        }
      </motion.div>
    </AnimatePresence>
  )
};
